import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {KeteranganKesehatanComponent} from "./keterangan-kesehatan.component";

const routes: Routes = [
  {
    path: 'keterangan-kesehatan',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: KeteranganKesehatanComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KeteranganKesehatanRoutingModule { }
